export const checkYearGroup = (year: number) => {
  const isSenior = year >= 7;
  const isJunior = year <= 6;

  return {
    isSenior,
    isJunior,
  };
};
